import { GroupBase, OptionProps, components } from "react-select";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { UserOption } from "@/features/session/types/user-option";

export function UserSelectOption(
  props: OptionProps<UserOption, boolean, GroupBase<UserOption>>,
) {
  const user = props.data;

  if (user.isExternal) {
    return <components.Option {...props}>{user.email}</components.Option>;
  }

  return (
    <components.Option {...props}>
      <div className="flex items-center">
        <Avatar>
          {/* <AvatarImage src="https://github.com/shadcn.png" /> */}
          <AvatarFallback className="bg-border capitalize text-muted">
            {user.firstName[0]}
            {user.lastName[0]}
          </AvatarFallback>
        </Avatar>
        <div className="ml-2">
          <p>
            {user.firstName} {user.lastName}
          </p>
          <p className="text-sm text-muted-foreground">{user.email}</p>
        </div>
      </div>
    </components.Option>
  );
}
